import { API_ADMIN_PATHS, MADERA_BACKOFFICE_PATHS } from "constants/constants";
import { Navigate, Outlet } from "react-router-dom";
import { isTokenAvailable } from "utilities/storageUtilities";
import { isApiAdministrator, isHMIToken } from "utilities/utilities";

export const ProtectedOsornoRoute = ({
    redirectPath = `/${MADERA_BACKOFFICE_PATHS.ROOT_PATH}/${MADERA_BACKOFFICE_PATHS.LOGIN}`,
}: {
    redirectPath?: string;
}) => {
    const token = isTokenAvailable();

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }

    if (isHMIToken()) {
        return <Navigate to={redirectPath} replace />;
    }

    // OS-2557: the API Administrator sees exactly one page. Hasura denies every MBO read under the
    // role, so this is confinement rather than a data guard — without it the MBO chrome mounts and
    // renders as a broken shell instead of returning the user to their portal.
    if (isApiAdministrator()) {
        return <Navigate to={`/${API_ADMIN_PATHS.ROOT_PATH}/${API_ADMIN_PATHS.KEYS}`} replace />;
    }

    return <Outlet />;
};
